import styled from '@emotion/styled'
import Link from 'next/link'
import { unifiedColors } from 'styles/colors'
import { theme, themeUtils } from 'styles/theme'

export const SeoLinkContainer = styled.div`
  & > :first-of-type {
    margin-right: 4px;
  }
`

export const StyledAnchor = styled(Link)`
  color: ${theme.palette.label.default};
  ${themeUtils.label}
  text-decoration: none;
  cursor: pointer;
  border-bottom: 4px solid ${unifiedColors.shadow.tertiary};
`
